import PropTypes from "prop-types";

import SuccessIcon from "assets/svg/form-success.svg";

import styles from "./styles.module.css";

const SaleCompleted = ({ projectCity, tradeType, category }) => {
  return (
    <div className={styles.successContainer}>
      <SuccessIcon className={styles.successIcon} />
      <p className={styles.successTitle}>Satışı Tamamlandı</p>
      <p className={styles.successText}>
        Bölgedeki benzer projeleri inceleyebilir ve size en uygun proje için form bırakabilirsiniz.
      </p>
      <a href={`/${tradeType.slug}-${category.slug}/${projectCity}/projeler`} className={styles.submitButton}>
        Benzer Projeleri İncele
      </a>
    </div>
  );
};

SaleCompleted.propTypes = {
  projectCity: PropTypes.string,
  tradeType: PropTypes.object,
  category: PropTypes.object,
};

export default SaleCompleted;
